module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "BlogYearSelector t-mono-xs"
  }, [_c('div', {
    staticClass: "BlogYearSelector-arrow",
    class: {
      'BlogYearSelector-arrow--isSelectable': _vm.showPreviousArrow
    },
    on: {
      "click": _vm.previous
    }
  }, [_vm._v("\n    <\n  ")]), _vm._v(" "), _c('div', {
    ref: "slider",
    staticClass: "BlogYearSelector-slider"
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year.year,
      ref: "item",
      refInFor: true,
      staticClass: "BlogYearSelector-item",
      attrs: {
        "to": year.route
      }
    }, [_vm._v("\n\n      " + _vm._s(year.year) + "\n\n    ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "BlogYearSelector-arrow",
    class: {
      'BlogYearSelector-arrow--isSelectable': _vm.showNextArrow
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n    >\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3ec6286"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlogYearSelector.vue
// module id = 791
// module chunks = 1474